<template>
  <v-footer class="text-center" id="foot">
    <v-row>
      <v-col
        :cols="mobileFriendlyFirstTwoItems"
        :align="logoPosition"
        id="footerLogo"
      >
        <v-img src="../../public/static/elmpologo.png" width="225" />
      </v-col>
      <v-col
        :cols="mobileFriendlyFirstTwoItems"
        id="footerLogo"
        :style="this.$vuetify.breakpoint.xs ? `font-size: .6em;` : ``"
      >
        <v-spacer></v-spacer>
        <span style="font-size: medium; color: white;">
          {{ $t("message.footer") }}
        </span>
        <br /><br />
        <v-btn @click="setLanguage" :disabled="pauseToggle">
          {{ $i18n.locale === "en" ? `Español` : `English` }}
        </v-btn>
      </v-col>
      <v-col :cols="mobileFriendly" :align="logoPosition" id="footerLogo">
        <span
          style="font-size: x-large; color: white; display: flex; align-items: center;"
        >
          {{ $t(`message.footerText`) }}
        </span>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      pauseToggle: false
    };
  },
  computed: {
    mobileFriendly() {
      if (this.$vuetify.breakpoint.xs) {
        return "12";
      }
      return "4";
    },
    mobileFriendlyFirstTwoItems() {
      if (this.$vuetify.breakpoint.xs) {
        return "6";
      }
      return "4";
    },
    logoPosition() {
      if (this.$vuetify.breakpoint.xs) {
        return "center";
      }
      return "left";
    }
  },
  methods: {
    setLanguage() {
      if (this.$i18n.locale === "en") {
        this.$i18n.locale = "es";
        this.pauseToggle = true;
        setTimeout(() => {
          this.pauseToggle = false;
        }, 1000);
      } else {
        this.$i18n.locale = "en";
        this.pauseToggle = true;
        setTimeout(() => {
          this.pauseToggle = false;
        }, 1000);
      }
    }
  }
};
</script>

<style scoped>
#foot {
  background-image: url("../assets/RMS 2050_FooterCrop.png");
  background-size: cover;
}
#footerLogo {
  background-color: rgba(112, 128, 144, 0.5);
}
</style>
